<template lang="pug">
  .buttons
    .btn.marginBotton
      el-button(
        type="default",
        @click="voltarAba",
        name="voltar"
        v-show="!isPrimeiroPasso"
      )
        span.center
          i.fas.fa-chevron-left
          span &nbsp Voltar
      el-button(
        @click="cancelar",
        name="cancelar"
        class="cancelarButton"
        v-show="showButtonCancelar && !isIntroPasso"
      )
        span.center
          i.fas.fa-times
          span &nbsp Cancelar
    .btn
      el-button.buttonMargin(
        type="success",
        @click="salvar",
        name="salvar",
        v-show="showButtonSalvar"
      )
        span.center
          i.fas.fa-save
          span &nbsp Salvar

      el-button(
        type="default",
        @click="download",
        name="download",
        v-show="showButtonDownload"
      )
        span.center
          span Download PDF &nbsp
          i.fa.fa-download

      el-button.buttonMargin(
        type="default",
        @click="proximo",
        name="proximo",
        v-show="!isUltimoPasso"
      )
        span.center
          span Próximo &nbsp
          i.fas.fa-chevron-right

      el-button(
        type="primary",
        @click="finalizar",
        name="finalizar",
        v-show="isUltimoPasso"
      )
        span.center
          i.fa.fa-check
          span &nbsp {{ finalizarLabel }}
</template>

<script>
export default {
  props: {
    isPrimeiroPasso: {
      type: Boolean,
      default: false
    },

    isUltimoPasso: {
      type: Boolean,
      default: false
    },

    showButtonSalvar: {
      type: Boolean,
      default: false
    },

    isEtapaSalva: {
      type: Boolean,
      default: true
    },

    showButtonCancelar: {
      type: Boolean,
      required: false,
      default: true
    },

    showButtonDownload: {
      type: Boolean,
      required: false,
      default: false
    },

    finalizarLabel: {
      type: String,
      required: false,
      default: 'Finalizar'
    },

    isIntroPasso: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    salvar () {
      this.$emit('salvar')
    },

    voltarAba () {
      this.$emit('voltar')
    },

    cancelar () {
      this.$emit('cancelar')
    },

    proximo () {
      this.$emit('proximo')
    },

    finalizar () {
      this.$emit('finalizar')
    },

    download () {
      this.$emit('download')
    }
  }

}
</script>

<style scoped lang="scss">

  .buttons {
    display: flex;
    justify-content:space-between;
    padding: 20px 10px 20px 10px;
  }

  .btn {
    display: flex;
  }

  .center {
    display: flex;
    align-items: center;
  }

  .icon {
    font-size: 16px;
  }
  .cancelarButton:hover, .cancelarButton:focus {
    background-color:#fef0f0;
    color: #f56c6c;
    border-color: #fbc4c4;
  }

  @media (max-width: 780px) {
    .buttons {
      flex-wrap: wrap-reverse;
      justify-content: center;
    }
    .marginBotton {
      padding: 20px;
    }

    .buttonMargin {
      margin: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/components/AppButtonsCadastroSicarf.vue